import { matchRoutes, useLocation } from 'react-router-dom';

import { routes as applicationRoutes } from '../routes';

import type { AppRouteObject } from '../routes';

interface UseCurrentRouteProps {
  routes?: AppRouteObject[];
}

const useCurrentRoute = (props: UseCurrentRouteProps = {}) => {
  const { routes } = props;
  const location = useLocation();
  const matches = matchRoutes(routes ?? applicationRoutes, location);

  if (matches === null) return { route: null };

  const { route: matchRoute } = matches[matches.length - 1];
  return { route: matchRoute };
};

export { useCurrentRoute };
